import debug from 'debug';
import Overlay from './overlay';

const log = debug('Overlay:MultiViewsOverlay');

class MultiViewsOverlay extends Overlay {
	constructor() {
		super();

		this.flippedEvent = this.flippedHandler.bind(this);

		this.initialize();
	}

	/**
	 * @param {Object} dom
	 */
	create(dom, customCss) {
		const container = this.mainForm.querySelector(`[data-overlay="container-${this.instanceId}"]`);
		const views = container.querySelectorAll('[data-view]');

		const view = document.createElement('div');
		view.setAttribute('class', `o-multi-views-overlay__view ${customCss !== undefined ? customCss : ''}`);
		view.setAttribute('data-view', views.length);

		dom.setAttribute('data-overlay', 'dom');

		view.appendChild(dom)
		container.appendChild(view);
	}

	eventListeners() {
		super.eventListeners();

		this.overlay.addEventListener('transitionend', this.flippedEvent, false);
	}

	/**
	 * @param {number} currentViewIndex
	 * @param {number} nextViewIndex
	 */
	flip(currentViewIndex, nextViewIndex) {
		this.currentView = this.overlay.querySelector(`[data-view="${currentViewIndex}"]`);
		this.nextView = this.overlay.querySelector(`[data-view="${nextViewIndex}"]`);

		this.currentView.classList.add('is-front');
		this.nextView.classList.add('is-back');
		this.nextView.classList.add('is-visible');

		setTimeout(() => {
			this.overlay.classList.add('is-flipped');
		}, 500);
	}

	/**
	 * @param {Event} event
	 */
	flippedHandler(event) {
		if (this.currentView === undefined) return;
		setTimeout(() => {
			this.currentView.classList.remove('is-visible');
			this.currentView.classList.remove('is-front');
			this.nextView.classList.remove('is-back');
			this.overlay.classList.remove('is-flipped');
		}, 1000);
	}

	initialize() {
		const container = document.createElement('section');
		container.setAttribute('class', 'o-multi-views-overlay');
		container.setAttribute('data-overlay', `container-${this.instanceId}`);

		this.mainForm.insertBefore(container, this.mainForm.firstChild);

		this.overlay = this.mainForm.querySelector(`[data-overlay="container-${this.instanceId}"]`);
		this.eventListeners();
	}

	isVisible(viewIndex) {
		const view = this.overlay.querySelector(`[data-view="${viewIndex}"]`);
		return view.classList.contains('is-visible');
	}

	/**
	 * @param {number} viewIndex
	 */
	show(viewIndex) {
		const view = this.overlay.querySelector(`[data-view="${viewIndex}"]`);
		log('show', viewIndex, view);
		view.classList.add('is-visible');

		super.show();
	}

}

export default MultiViewsOverlay;
